import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillUrlTextV1FieldComponent } from './fill-url-text-v1/fill-url-text-v1.component';
import { ViewUrlTextV1FieldComponent } from './view-url-text-v1/view-url-text-v1.component';
import { SettingsUrlTextV1FieldComponent } from './settings-url-text-v1/settings-url-text-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillUrlTextV1FieldComponent,
        ViewUrlTextV1FieldComponent,
        SettingsUrlTextV1FieldComponent
    ],
    exports: [
        FillUrlTextV1FieldComponent,
        ViewUrlTextV1FieldComponent,
        SettingsUrlTextV1FieldComponent
    ],

})
export class CoreCustomFormsFieldUrlTextV1FieldsModule { }
